<template>
  <div class="app-container">
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-date-picker
              v-model="search.startDate"
              type="date"
              placeholder="请选择开始日期"
              style="width:100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-col>
          <el-col :span="3">
            <el-date-picker
              v-model="search.endDate"
              type="date"
              placeholder="请选择结束日期"
              style="width:100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="search.userId"
              filterable
              clearable
              placeholder="请选择人员"
              style="width:100%"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.label"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col
            :span="12"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
            <el-button
              v-if="isExport"
              type="warning"
              @click="exportExcel(0)"
            >
              导出水印图
            </el-button>
            <el-button
              v-if="isExport"
              type="warning"
              @click="exportExcel(1)"
            >
              导出原图
            </el-button>
            <el-button
              v-if="isExport"
              type="danger"
              @click="rotateMorePhoto(1)"
            >
              批量左旋转
            </el-button>
            <el-button
              v-if="isExport"
              type="danger"
              @click="rotateMorePhoto(2)"
            >
              批量右旋转
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div
        v-loading.fullscreen.lock="loading"
        class="photo-data-list"
      >
        <div
          v-for="(dateItem,itemIndex) in datePhotoList"
          :key="itemIndex"
          class="date-list-view"
        >
          <div class="date-text-view">
            {{ dateItem.filmingDateCN }}
            <el-checkbox
              v-model="dateItem.checked"
              style="padding-left:20px;"
              @change="(val) => {changeCheckHandler(val,dateItem,1)}"
            >
              全选
            </el-checkbox>
          </div>
          <div
            v-for="(addressItem,addressIndex) in dateItem.photoAddressList"
            :key="addressIndex"
          >
            <div class="date-text-view-address">
              {{ addressItem.filmingAddress }}
              <el-checkbox
                v-model="addressItem.checked"
                style="padding-left:20px;"
                @change="(val) => {changeCheckHandler(val,addressItem,2)}"
              >
                全选
              </el-checkbox>
            </div>
            <div class="photo-list-view">
              <div
                v-for="(file,index) in addressItem.photoList"
                :key="index"
                class="img-list"
              >
                <div
                  class="img-item"
                >
                  <el-image
                    :src="file.url"
                    :fit="'contain'"
                    style="width:218px;height:218px;"
                    @error="loadError()"
                  >
                    <div
                      slot="error"
                      class="image-error"
                    >
                      <i class="el-icon-picture-outline" />
                    </div>
                  </el-image>
                  <i
                    v-if="file.type === 2"
                    class="el-icon-video-play play-icon-view"
                  />
                  <span style="margin:5px 0;">{{ file.filmingDatetimeStr }}</span>
                  <span
                    v-if="file.referencedNo"
                    style="margin:5px 0; color: red; font-size: 12px;"
                  >{{ file.referencedNo + ' 引用' }}</span>
                </div>
                <el-checkbox
                  v-model="file.checked"
                  class="img-checkbox-class"
                />
                <div
                  class="button-mask-class"
                >
                  <div class="button-mask-div-class">
                    <el-tooltip
                      content="放大"
                      placement="top"
                    >
                      <span class="icon-span-class">
                        <i
                          class="el-icon-zoom-in icon-class"
                          @click="showImage(addressItem.photoList,index)"
                        />
                      </span>
                    </el-tooltip>
                    <el-tooltip
                      content="选中/取消选中"
                      placement="top"
                    >
                      <span
                        class="icon-span-class"
                      >
                        <i
                          class="el-icon-circle-check icon-class"
                          @click="checkItem(addressItem.photoList,index)"
                        />
                      </span>
                    </el-tooltip>
                    <el-tooltip
                      content="取消报告引用"
                      placement="top"
                    >
                      <span
                        class="icon-span-class"
                      >
                        <i
                          class="el-icon-link icon-class"
                          @click="cancelItem(addressItem.photoList,index)"
                        />
                      </span>
                    </el-tooltip>
                  </div>
                  <div class="button-mask-div-class">
                    <el-tooltip
                      content="左旋转"
                      placement="bottom"
                    >
                      <span class="icon-span-class">
                        <i
                          class="el-icon-refresh-left icon-class"
                          @click="rotateOnePhoto(addressItem.photoList,index, 1)"
                        />
                      </span>
                    </el-tooltip>
                    <el-tooltip
                      content="右旋转"
                      placement="bottom"
                    >
                      <span
                        class="icon-span-class"
                      >
                        <i
                          class="el-icon-refresh-right icon-class"
                          @click="rotateOnePhoto(addressItem.photoList,index, 2)"
                        />
                      </span>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 2、图片预览 -->
      <el-dialog
        :visible.sync="dialogImageVisible"
        class="preview-dialog"
        :close-on-press-escape="false"
        :show-close="false"
        append-to-body
      >
        <!-- 技术点：一定使用v-if="dialogVisible" 不能使用v-show,否则图片展示时（假设点击的是第3张），前两张会快速的滑过-->
        <div
          v-if="dialogImageVisible"
          class="block"
        >
          <el-carousel
            trigger="click"
            :height="carouselHeight"
            :autoplay="false"
            arrow="always"
            indicator-position="none"
          >
            <el-carousel-item
              v-for="(item,index) in imagesPreview"
              :key="index"
            >
              <img
                :src="item.url"
                style="max-height: 100%; max-width: 100%;"
              >
            </el-carousel-item>
          </el-carousel>
          <span
            class="el-image-viewer__btn el-image-viewer__close close-index"
            @click="modalImageClose"
          ><i class="el-icon-error" /></span>
        </div>
      </el-dialog>
      <!-- 视频播放 -->
      <el-dialog
        v-if="dialogVideoVisible"
        title="播放视频"
        :visible.sync="dialogVideoVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        destroy-on-close
        append-to-body
        class="abow_dialog"
        width="1100px"
      >
        <div style="width: 100%;height:100%;text-align: center;">
          <video
            :src="videoUrl"
            controls="controls"
            class="avatar video-avatar"
            style="width: 100%;height:100%;"
          >
            您的浏览器不支持视频播放
          </video>
        </div>
        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            @click="dialogVideoVisible=false"
          >
            关闭
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// 权限验证
import checkPermission from '@/utils/permission'
// 数据请求
import { loadUserSelectDataApi } from '@/api/user'
import { loadAppAlbumPhotoInfoApi, exportAppAlbumPhotoInfoApi, updatePhotoCancelCameraAndReportRelationApi, rotatePhotoByConditionApi } from '@/api/appAlbum'
export default {
  name: 'AppAlbumPhotoInfo',
  components: {
  },
  mixins: [],
   data () {
    return {
      loading: false,
      // 查询条件
      search: {
        startDate: '',
        endDate: '',
        userId: ''
      },
      isExport: false,
      userOptions: [],
      datePhotoList: [],
      baseUrl: '',
      nasUrl: '',
      dialogImageVisible: false, // 预览照片窗口是否展示，默认不展示
      imagesPreview: [],// 预览时根据点击的index重组的数据
      dialogVideoVisible: false,
      videoUrl: '',
      carouselHeight: ''
    }
  },
   created () {
    if (checkPermission(['app_album_photo_info_export'])) {
      this.isExport = true
    }
    this.carouselHeight = (window.innerHeight - 100) + 'px'
    this.baseUrl = process.env.VUE_APP_BASE_API
    this.nasUrl = process.env.VUE_APP_NAS_API
    this.initUserData()
  },
  methods: {
    // 计算表格高度
    comptedTableHeight () {
      let dHeight = document.body.clientHeight
      let searchHeight = this.$refs.searchCondition.clientHeight
      this.tableHeight = dHeight - searchHeight - 119 + 'px'
    },
    // 查询
    searchData () {
      if(this.search.startDate === '' || this.search.endDate === ''){
        this.$message({ message: '请选择开始和结束日期', type: 'warning' })
        return
      }
      if(this.search.userId === null || this.search.userId === ''){
        this.$message({ message: '请选择人员', type: 'warning' })
        return
      }
      this.loading = true
      this.datePhotoList = []
      let startDate = ''
      let endDate = ''
      if(this.search.startDate && this.search.startDate.length > 0){
        startDate = this.search.startDate + ' 00:00:00'
      }
      if(this.search.endDate && this.search.endDate.length > 0){
        endDate = this.search.endDate + ' 23:59:59'
      }
      loadAppAlbumPhotoInfoApi({searchStartDate: startDate, searchEndDate: endDate, userIds: this.search.userId, orderCondition: 'order by filming_datetime desc'}).then(res => {
        this.loading = false
        let resData = res.data ? res.data : []
        let timeString = new Date().getTime()
        let nasYearMonth = Number(new Date().getFullYear() - 1) + '12'
        resData.forEach(item => {
            item.photoAddressList.forEach(photoAddressItem => {
              photoAddressItem.checked = false
              photoAddressItem.photoList.forEach(photoItem => {
                let url = ''
                if(photoItem.type === 2){
                  url = photoItem.coverUrl
                } else {
                  url = photoItem.baseWatermarkUrl
                }
                if(photoItem.thumbnailWatermarkUrl){
                  url = photoItem.thumbnailWatermarkUrl
                }
                let yearMonth = url.split('/')[3].substring(0,6)
                if(Number(nasYearMonth) > Number(yearMonth)){
                  photoItem.url = this.nasUrl + url + '?t=' + timeString
                } else {
                  photoItem.url = this.baseUrl + url + '?t=' + timeString
                }
                photoItem.checked = false
              })
            })
        })
        this.datePhotoList = resData
        this.datePhotoList.forEach(item => {
          item.checked = false
        })
        if(this.datePhotoList.length === 0){
          this.$message({
            message: '未能查找到符合条件的数据',
            type: 'success'
          });
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 初始用户数据
    initUserData(){
      loadUserSelectDataApi({status: 1}).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.userOptions.push({ label: item.name, data: item.id })
          if (this.eventType === 'add') {
            this.loading = false
          }
        })
      })
    },
    /** 图片加载失败调用 */
    loadError () {
    },
    /** 图片预览 */
    showImage (photoList,index) {
      this.imagesPreview = []
      let fileArr = []
      fileArr.push(photoList[index])
      let file = fileArr[0]
      let nasYearMonth = Number(new Date().getFullYear() - 1) + '12'
      if(file.originalVideoUrl.indexOf('.mp4') !== -1 || file.originalVideoUrl.indexOf('.avi') !== -1 || file.originalVideoUrl.indexOf('.wmv') !== -1 || file.originalVideoUrl.indexOf('.mov') !== -1 || file.originalVideoUrl.indexOf('.MP4') !== -1 || file.originalVideoUrl.indexOf('.AVI') !== -1 || file.originalVideoUrl.indexOf('.WMV') !== -1 || file.originalVideoUrl.indexOf('.MOV') !== -1){
        let yearMonth = file.originalVideoUrl.split('/')[3].substring(0,6)
        if(Number(nasYearMonth) > Number(yearMonth)){
          this.videoUrl = this.nasUrl + file.originalVideoUrl
        } else {
          this.videoUrl = this.baseUrl + file.originalVideoUrl
        }
        this.dialogVideoVisible = true
      } else {
        this.dialogImageVisible = true
        let yearMonth = file.baseWatermarkUrl.split('/')[3].substring(0,6)
        if(Number(nasYearMonth) > Number(yearMonth)){
          fileArr[0].url = this.nasUrl + file.baseWatermarkUrl
        } else {
          fileArr[0].url = this.baseUrl + file.baseWatermarkUrl
        }
        this.imagesPreview = fileArr
      }
    },
    /**选中*/
    checkItem(photoList,index){
      photoList[index].checked = !photoList[index].checked
    },
    /**取消引用*/
    cancelItem(photoList,index){
      let _this = this
      _this.$confirm(
        '是否确认取消该照片的活动报告引用？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      )
      .then(async () => {
        let photoId = photoList[index].id
        _this.loading = true
        updatePhotoCancelCameraAndReportRelationApi({photoId: photoId}).then(res => {
          console.log(res.data)
          _this.$message({ message: '数据处理成功', type: 'success' })
          photoList[index].referencedNo = ''
          _this.$forceUpdate()
          _this.loading = false
        }).catch(() => {
          _this.loading = false
        })
      })
      .catch(() => { })
    },
    modalImageClose () {
      this.dialogImageVisible = false
    },
    // 点击全选
    changeCheckHandler(checked, dateItem, type){
      if(type === 1){
        dateItem.photoAddressList.forEach(addressItem => {
          addressItem.checked = checked
          addressItem.photoList.forEach(photoItem => {
            photoItem.checked = checked
          })
        })
      } else if (type === 2){
        dateItem.photoList.forEach(photoItem => {
          photoItem.checked = checked
        })
      }
    },
    // 导出数据API
    exportExcel (type) {
      if (this.datePhotoList.length === 0) {
        this.$message({ message: '无数据，不能导出', type: 'warning' })
        return
      }
      let ids = ''
      let count = 0
      this.datePhotoList.forEach(item => {
        item.photoAddressList.forEach(addressItem => {
          addressItem.photoList.forEach(photoItem => {
            if(photoItem.checked){
              ids += ',' + photoItem.id
              count += 1
            }
          })
        })
      })
      if(ids.length > 0){
        ids = ids.substring(1)
      } else {
        this.$message({ message: '无选中的照片，不能导出', type: 'warning' })
        return
      }
      if(count > 200){
        this.$message({ message: '选中照片数量最大200张', type: 'warning' })
        return
      }
      let params = {
        userId: this.search.userId,
        searchType: type,
        ids: ids
      }
      exportAppAlbumPhotoInfoApi(params).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    },
    //旋转单张照片
    rotateOnePhoto(photoList,index, rotateType){
      let _this = this
      _this.$confirm(
        '是否确认'+(rotateType === 1? '左' : '右' )+'旋转该照片？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      )
      .then(async () => {
        let photoId = photoList[index].id
        _this.loading = true
        rotatePhotoByConditionApi({photoIds: photoId, rotateType: rotateType}).then(() => {
          setTimeout(()=>{
            _this.$message({ message: '旋转成功', type: 'success' })
            let url = photoList[index].url
            photoList[index].url = url.split('?t=')[0] + '?t=' + new Date().getTime()
            _this.$forceUpdate()
            _this.loading = false
          },5000)
        }).catch(() => {
          _this.loading = false
        })
      })
      .catch(() => { })
    },
    // 批量旋转
    rotateMorePhoto(rotateType){
      let _this = this
      if (_this.datePhotoList.length === 0) {
        _this.$message({ message: '无数据，不能处理', type: 'warning' })
        return
      }
      let ids = ''
      _this.datePhotoList.forEach(item => {
        item.photoAddressList.forEach(addressItem => {
          addressItem.photoList.forEach(photoItem => {
            if(photoItem.checked){
              ids += ',' + photoItem.id
            }
          })
        })
      })
      if(ids.length > 0){
        ids = ids.substring(1)
      } else {
        _this.$message({ message: '无选中的照片，不能处理', type: 'warning' })
        return
      }
      let params = {
        rotateType: rotateType,
        photoIds: ids
      }
      _this.$confirm(
        '是否确认批量'+(rotateType === 1? '左' : '右' )+'旋转所选照片？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      )
      .then(async () => {
        _this.loading = true
        rotatePhotoByConditionApi(params).then(() => {
          setTimeout(()=>{
            let timeString = new Date().getTime()
            _this.$message({ message: '批量旋转成功', type: 'success' })
            _this.datePhotoList.forEach(item => {
              item.photoAddressList.forEach(addressItem => {
                addressItem.photoList.forEach(photoItem => {
                  if(photoItem.checked){
                    photoItem.url = photoItem.url.split('?t=')[0] + '?t=' + timeString
                  }
                })
              })
            })
            _this.$forceUpdate()
            _this.loading = false
          },5000)
        }).catch(() => {
          _this.loading = false
        })
      })
      .catch(() => { })
    },
  }
}
</script>
<style lang="scss" scoped>
.photo-data-list{
    width: 100%;
    display: flex;
    flex-direction: column;

    .date-list-view{
        display: flex;
        flex-direction: column;
        margin-left: 15px;
        
        .date-text-view{
            font-size: 18px;
            font-weight: bold;
            margin: 10px 0 2px 20px;
            display: flex;
        }

        .date-text-view-address{
          font-size: 14px;
          color: #3b3b3b;
          margin: 5px 0 5px 20px;
        }

        .photo-list-view{
            width: 100%;
            display: flex;
            flex-wrap: wrap;

            .img-list{
                flex: 0 0 218px;
                margin-right:8px;
                width:218px;
                display:flex;
                flex-direction: column;
                align-items:center;
                overflow:hidden;
                border: 1px solid #c0ccda;
                position: relative;

                .img-item{
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    text-align: center;

                    .play-icon-view{
                        position: absolute;
                        left: 70px;
                        top: 70px;
                        font-size: 80px;
                        color: #c0ccda;
                    }
                }
            }
            .img-checkbox-class{
                position: absolute;
                right: 0;
                margin-right: 5px;
                margin-top: 5px;

                ::v-deep .el-checkbox__inner{
                    width: 24px !important;
                    height: 24px !important;
                    border-color: #1183fb;
                    border-radius: 50%;
                }

                ::v-deep .el-checkbox__inner::after{
                    height: 14px;
                    width: 6px;
                    left: 7px;
                }
            }
        }
    }
}
.preview-dialog{
    width:100%;
    height:100%;

    ::v-deep .el-dialog{
        margin-top: 30px !important;
        width: 90vw !important;
    }

    .close-index{
        z-index: 100;
    }
}
.el-carousel__item {
    text-align: center;
}
.button-mask-class {
  width: 218px;
  height: 218px;
  position: absolute;
  background: rgba(0, 0, 0, 0.5); /* 半透明背景 */
  z-index: 1000; /* 层级高于其他内容 */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
}
.button-mask-div-class{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
}
.img-list:hover .button-mask-class{
  opacity: 1;
}
.icon-span-class {
  margin: 0 20px;
}
.icon-class {
  font-size: 28px;
  color: #fff;
}
.icon-class:hover {
  cursor: pointer;
}
</style>